import styled, { css } from "styled-components";

export const DecorativeDot = styled.img`
  aspect-ratio: 1;
  object-fit: contain;
  width: 9px;
  height: 9px;
  margin-left: 5px;
  ${({ $large }) =>
    $large
      ? css`
          width: 11px;
          height: 11px;
        `
      : css`
          width: 9px;
          height: 9px;
        `}

  @media ${({ theme }) => theme.media.mobile} {
    margin-left: 4px;
    ${({ $large }) =>
      $large
        ? css`
            width: 8px;
            height: 8px;
          `
        : css`
            width: 7px;
            height: 7px;
          `}
  }
`;

export const DecorativeDots = styled.img.attrs(({ $color }) => ({
  src: `/images/icons/dot-${$color || "black"}.svg`,
  alt: "Decorative dots",
}))`
  aspect-ratio: 1;
  object-fit: contain;
  width: 9px;
  height: 9px;

  ${({ $large }) =>
    $large
      ? css`
          width: 11px;
          height: 11px;
        `
      : css`
          width: 9px;
          height: 9px;
        `}

  @media ${({ theme }) => theme.media.mobile} {
    ${({ $large }) =>
      $large
        ? css`
            width: 8px;
            height: 8px;
          `
        : css`
            width: 7px;
            height: 7px;
          `}
  }
`;

export const Nowrap = styled.span`
  white-space: nowrap;
`;
